import { graphql } from '@/gql';

export const SubmitPerformanceMarch20KmResultMutation = graphql(`
    mutation SubmitPerformanceMarch20KmResult($input: SubmitMarch20KmResultInput!) {
        submitMarch20KmResult(input: $input) {
            ... on SubmitMarch20KmResultSuccessfulResponse {
                result {
                    ...March20kmPerformanceResult
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

const March20kmPerformanceResult = graphql(`
    fragment March20kmPerformanceResult on PerformanceResult {
        id
        companyId
        company {
            id
            name
        }
        userId
        user {
            __typename
            ... on TenantUser {
                id
                name
                email
            }
        }
        isTiedToAssessmentRun
        assessmentRunId
        assessmentRun {
            name
        }
        result {
            __typename
            ... on March20kmResult {
                ...March20kmPerformanceResultData
            }
        }
        createdAt
        completedAt
        updatedAt
        updatedBy
        isDeleted
    }
`);

const March20kmPerformanceResultData = graphql(`
    fragment March20kmPerformanceResultData on March20kmResult {
        timingSec
        result
    }
`);
